/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Property / address record
 * @export
 * @interface Property
 */
export interface Property {
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    readonly id: number;
    /**
     * PA firm that owns this record
     * @type {number}
     * @memberof Property
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    streetAddress: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof Property
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Property
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Property interface.
 */
export function instanceOfProperty(value: object): value is Property {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('streetAddress' in value) || value['streetAddress'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PropertyFromJSON(json: any): Property {
    return PropertyFromJSONTyped(json, false);
}

export function PropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Property {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'streetAddress': json['streetAddress'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'city': json['city'],
        'state': json['state'],
        'zipCode': json['zipCode'],
        'country': json['country'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function PropertyToJSON(json: any): Property {
    return PropertyToJSONTyped(json, false);
}

export function PropertyToJSONTyped(value?: Omit<Property, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'streetAddress': value['streetAddress'],
        'unit': value['unit'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'notes': value['notes'],
        'createdBy': value['createdBy'],
    };
}

